"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _immutable = require("immutable");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _PropertyFormHeader = _interopRequireDefault(require("MeetingsLib/components/header/PropertyFormHeader"));

var _BookingFormFields = _interopRequireDefault(require("MeetingsLib/components/input/BookingFormFields"));

var _StepButtonsFooter = _interopRequireDefault(require("MeetingsLib/components/page/StepButtonsFooter"));

var _UsageTracker = require("MeetingsLib/tracking/UsageTracker");

var _AutoSubmitSelector = require("MeetingsLib/selectors/AutoSubmitSelector");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _FormFieldValidationSelector = require("MeetingsLib/selectors/FormFieldValidationSelector");

var _RequestStatusSelectors = require("MeetingsLib/selectors/RequestStatusSelectors");

var _FormState = _interopRequireDefault(require("MeetingsLib/models/FormState"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var PropertyForm = (0, _createReactClass.default)({
  propTypes: {
    // passed
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    canSubmitInitialPropertyForm: _propTypes.default.bool.isRequired,
    compact: _propTypes.default.bool,
    goToPreviousStep: _propTypes.default.func.isRequired,
    submittingMeeting: _propTypes.default.bool,
    //loaded
    canSubmitStagedPropertyForm: _propTypes.default.bool,
    centerPropertyForm: _propTypes.default.bool,
    dateTime: _propTypes.default.number.isRequired,
    formFields: _propTypes.default.instanceOf(_immutable.List).isRequired,
    stagedFormState: _propTypes.default.instanceOf(_FormState.default),
    formStateValidation: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    legalConsentEnabled: _propTypes.default.bool.isRequired,
    offline: _propTypes.default.bool,
    setFormValue: _propTypes.default.func.isRequired,
    setFormState: _propTypes.default.func.isRequired,
    resetFormState: _propTypes.default.func.isRequired,
    userTimezone: _propTypes.default.string.isRequired
  },
  componentDidMount: function componentDidMount() {
    (0, _UsageTracker.track)('meetingsLibViewScreen', {
      stage: 'form'
    });
  },
  shouldCenterForm: function shouldCenterForm() {
    var _this$props = this.props,
        compact = _this$props.compact,
        centerPropertyForm = _this$props.centerPropertyForm;
    return !compact && centerPropertyForm;
  },
  handleGoToPreviousStep: function handleGoToPreviousStep() {
    var _this$props2 = this.props,
        resetFormState = _this$props2.resetFormState,
        goToPreviousStep = _this$props2.goToPreviousStep;
    resetFormState();
    goToPreviousStep();
  },
  renderFormFields: function renderFormFields() {
    var _this$props3 = this.props,
        formFields = _this$props3.formFields,
        stagedFormState = _this$props3.stagedFormState,
        formStateValidation = _this$props3.formStateValidation,
        setFormValue = _this$props3.setFormValue;
    return _react.default.createElement("div", {
      className: "form-body width-100 m-bottom-7 overflow-y-scroll overflow-x-hidden",
      key: "fields"
    }, _react.default.createElement(_BookingFormFields.default, {
      centerPropertyForm: this.shouldCenterForm(),
      formFields: formFields,
      formState: stagedFormState,
      formStateValidation: formStateValidation,
      setFormValue: setFormValue
    }));
  },
  renderFormHeader: function renderFormHeader() {
    var _this$props4 = this.props,
        offline = _this$props4.offline,
        userTimezone = _this$props4.userTimezone,
        dateTime = _this$props4.dateTime;
    return _react.default.createElement(_PropertyFormHeader.default, {
      centerPropertyForm: this.shouldCenterForm(),
      offline: offline,
      userTimezone: userTimezone,
      dateTime: dateTime
    });
  },
  renderFormButtons: function renderFormButtons() {
    var _this$props5 = this.props,
        branding = _this$props5.branding,
        submittingMeeting = _this$props5.submittingMeeting,
        canSubmitStagedPropertyForm = _this$props5.canSubmitStagedPropertyForm,
        legalConsentEnabled = _this$props5.legalConsentEnabled,
        setFormState = _this$props5.setFormState,
        stagedFormState = _this$props5.stagedFormState,
        offline = _this$props5.offline;
    return _react.default.createElement(_StepButtonsFooter.default, {
      branding: branding,
      submittingMeeting: submittingMeeting,
      canProceed: canSubmitStagedPropertyForm,
      tooltipTitle: _react.default.createElement(_FormattedMessage.default, {
        message: "buttons.tooltip.formIncompleteOrHasErrors"
      }),
      goToPreviousStep: this.handleGoToPreviousStep,
      goToNextStep: function goToNextStep() {
        return setFormState(stagedFormState);
      },
      isLastStep: !legalConsentEnabled,
      offline: offline,
      key: "buttons"
    });
  },
  render: function render() {
    var canSubmitInitialPropertyForm = this.props.canSubmitInitialPropertyForm;
    var formContent = [this.renderFormFields(), this.renderFormButtons()];
    return _react.default.createElement(_UICardWrapper.default, {
      className: "height-100"
    }, _react.default.createElement(_UICardSection.default, {
      className: "height-100 p-y-6"
    }, _react.default.createElement(_UIFlex.default, {
      className: "height-100",
      direction: "column",
      justify: "around"
    }, this.renderFormHeader(), canSubmitInitialPropertyForm ? _react.default.createElement(_UILoadingSpinner.default, {
      size: "medium",
      grow: true
    }) : [formContent])));
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    canSubmitStagedPropertyForm: (0, _AutoSubmitSelector.canSubmitStagedPropertyForm)(state),
    centerPropertyForm: (0, _BookInfoSelectors.shouldCenterPropertyForm)(state),
    dateTime: (0, _BookInfoSelectors.getEvent)(state).dateTime,
    formFields: (0, _BookInfoSelectors.getCustomParams)(state).formFields,
    stagedFormState: state.stagedFormState,
    formStateValidation: (0, _FormFieldValidationSelector.getStagedFormFieldValidation)(state),
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    legalConsentEnabled: (0, _BookInfoSelectors.getCustomParams)(state).legalConsentEnabled,
    offline: (0, _BookInfoSelectors.getOffline)(state),
    userTimezone: state.userTimezone
  };
}, FormActions)(PropertyForm);

exports.default = _default;
module.exports = exports.default;